import cn from 'classnames'
import { useState } from 'react'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'
import { useGetTopicsForHeaderQuery } from 'src/graphql/generated/hooks'

interface CategoryListProps {
  listCategory: string[]
  className?: string
}

const CategoryList: React.FC<CategoryListProps> = ({ listCategory, className }) => {
  const [active, setActive] = useState(false)
  const handleClick = () => {
    setActive(!active)
  }

  const { data: topics } = useGetTopicsForHeaderQuery({ fetchPolicy: 'cache-first' })

  const findTopic = (subTopicName: string) => {
    const find = topics?.topics?.data.filter((item) => {
      const subTopics = item?.attributes?.subTopics?.data
      return subTopics?.some((subTopic) => subTopic?.attributes?.name === subTopicName)
    })

    return find && find.length > 0
      ? `/topics/${find[0]?.attributes?.slug}/${
          find[0].attributes?.subTopics?.data.filter((item) => item.attributes?.name === subTopicName)[0]?.attributes
            ?.slug
        }`
      : ''
  }

  return (
    <div className={cn(className, 'flex flex-wrap items-center')}>
      {listCategory.map((item: string, index: number) => {
        if (index < 4) {
          return (
            <CompatibleLink
              href={findTopic(item)}
              key={index}
              className="flex bg-clouds text-textdark text-[0.8125rem] font-primary font-medium items-center text-center rounded-[15px] mt-1.5 mr-4 px-[14px] h-[30px]"
            >
              {item}
            </CompatibleLink>
          )
        } else {
          if (active) {
            return (
              <CompatibleLink
                href={findTopic(item)}
                key={index}
                className="flex bg-clouds text-textdark text-[0.8125rem] font-primary font-medium items-center text-center rounded-[15px] mt-1.5 mr-4 px-[14px] h-[30px]"
              >
                {item}
              </CompatibleLink>
            )
          } else {
            return <div key={index}></div>
          }
        }
      })}
      {!active && listCategory.length > 4 && (
        <div
          className="h-[1.25rem] text-textdark text-[0.8125rem] font-primary font-medium mt-1.5"
          onClick={handleClick}
        >
          +{listCategory.length - 4} {listCategory.length - 4 === 1 ? 'more category' : 'more categories'}
        </div>
      )}
    </div>
  )
}

export default CategoryList
